import axios from "axios";

const apiBaseUrl = import.meta.env.VITE_API_URL || "";
const apiAppBaseUrl = import.meta.env.VITE_APP_API_URL || "";

const INTERNAL_USER_EMAIL = import.meta.env.VITE_INTERNAL_USER_EMAIL || "";
const INTERNAL_USER_PASSWORD = import.meta.env.VITE_INTERNAL_USER_PASSWORD || "";

// Cache para tokens internos
let cachedAppToken: string | null = null;
let cachedBackofficeToken: string | null = null;
let appTokenExpiry: number = 0;
let backofficeTokenExpiry: number = 0;

const TOKEN_CACHE_DURATION = 50 * 60 * 1000; // 50 minutos (tokens geralmente expiram em 1 hora)

/**
 * Obtém token interno para a API App (api-qas.talk2buy.com.br)
 */
export async function getInternalAppToken(): Promise<string> {
  const now = Date.now();
  
  // Retorna token em cache se ainda válido
  if (cachedAppToken && now < appTokenExpiry) {
    return cachedAppToken;
  }

  try {
    const response = await axios.post(`${apiAppBaseUrl}/api/v1/login`, {
      login: INTERNAL_USER_EMAIL,
      password: INTERNAL_USER_PASSWORD,
    });

    const accessToken = response.data.accessToken;
    
    if (!accessToken) {
      throw new Error("Failed to get internal app token");
    }

    // Cache o token
    cachedAppToken = accessToken;
    appTokenExpiry = now + TOKEN_CACHE_DURATION;

    return accessToken;
  } catch (error) {
    console.error("Error getting internal app token:", error);
    throw error;
  }
}

/**
 * Obtém token interno para a API Backoffice (api-backoffice-qas.talk2buy.com.br)
 */
export async function getInternalBackofficeToken(): Promise<string> {
  const now = Date.now();
  
  // Retorna token em cache se ainda válido
  if (cachedBackofficeToken && now < backofficeTokenExpiry) {
    return cachedBackofficeToken;
  }

  try {
    const response = await axios.post(`${apiBaseUrl}/v1/login`, {
      login: INTERNAL_USER_EMAIL,
      password: INTERNAL_USER_PASSWORD,
    });

    const accessToken = response.data.accessToken;
    
    if (!accessToken) {
      throw new Error("Failed to get internal backoffice token");
    }

    // Cache o token
    cachedBackofficeToken = accessToken;
    backofficeTokenExpiry = now + TOKEN_CACHE_DURATION;

    return accessToken;
  } catch (error) {
    console.error("Error getting internal backoffice token:", error);
    throw error;
  }
}

/**
 * Limpa o cache de tokens (útil para testes ou quando necessário forçar renovação)
 */
export function clearTokenCache(): void {
  cachedAppToken = null;
  cachedBackofficeToken = null;
  appTokenExpiry = 0;
  backofficeTokenExpiry = 0;
}
